module.exports = __webpack_public_path__ + "media/speakertest.6c1362c8.mp3";